(function () {
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var menu = document.getElementById('MobileMenu');
      if (menu) {
        var closed = menu.hasAttribute('hidden');
        if (closed) { menu.removeAttribute('hidden'); } else { menu.setAttribute('hidden', ''); }
        toggle.setAttribute('aria-expanded', String(closed));
      }
    }
    var step = e.target.closest && e.target.closest('[data-qty]');
    if (step) {
      var wrap = step.closest('.qty');
      if (wrap) {
        var input = wrap.querySelector('input');
        var dir = step.getAttribute('data-qty') === 'up' ? 1 : -1;
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + dir);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
})();
